import {Injectable} from '@angular/core'
import {UntypedFormGroup} from '@angular/forms'
import {Subject, Subscription} from 'rxjs'
import {Uszkodzenie} from '../../../../../../../../store/zbior-uszkodzen/zbiorUszkodzen';


@Injectable({
  providedIn: 'root'
})
export class FormularzUszkodzenService {

  public ostatnioDodanyFormularz!: UntypedFormGroup
  public czyFormularzJestPoprawny = new Subject<boolean>()
  public formularzLokalizacjiUszkodzenia!: UntypedFormGroup;

  private formularzUszkodzen = new UntypedFormGroup({})
  private dodaneUszkodzenia: Uszkodzenie<any>[] = []
  private poprawnoscFormularzaSubscription: Subscription[] = []

  constructor() {
    this.sprawdzPoprawnoscFormularza(this.formularzUszkodzen)
  }

  sprawdzPoprawnoscFormularzaSubscribe(formularz: UntypedFormGroup): void {
    this.poprawnoscFormularzaSubscription.push(
      formularz.valueChanges.subscribe(() => {
          this.sprawdzPoprawnoscWszystkichPodformularzy()
        }
      ))
  }

  sprawdzPoprawnoscWszystkichPodformularzy(): boolean {
    const podformularzeUszkodzen = Object.keys(this.formularzUszkodzen.controls)
    let wszystkiePodformularzePoprawne = podformularzeUszkodzen.length !== 0;

    podformularzeUszkodzen.forEach(key => {
      wszystkiePodformularzePoprawne = this.sprawdzPoprawnoscFormularza(this.formularzUszkodzen.controls[key] as UntypedFormGroup) && wszystkiePodformularzePoprawne
    });

    this.czyFormularzJestPoprawny.next(wszystkiePodformularzePoprawne);
    return wszystkiePodformularzePoprawne;
  }

  sprawdzWalidacjeWDodanychFormularzach(): void {
    Object.values(this.formularzUszkodzen.controls)
      .filter(podformularzUszkodzen => podformularzUszkodzen !== this.ostatnioDodanyFormularz)
      .map(form => form as UntypedFormGroup)
      .map(podformularz => Object.values(podformularz.controls).map(obiektPodformularza => this.sprawdzWalidacjeDlaObiektuPodformularza(obiektPodformularza)));

    if (!!this.formularzLokalizacjiUszkodzenia) {
      this.sprawdzWalidacjeWFormularzuLokalizacjiUszkodzenia();
    }
  }

  private sprawdzWalidacjeDlaObiektuPodformularza(obiektPodformularza: any): void {
    if (obiektPodformularza instanceof UntypedFormGroup) {
      Object.values(obiektPodformularza.controls)
        .filter(obiekt => obiekt instanceof UntypedFormGroup && obiekt !== this.ostatnioDodanyFormularz)
        .map(form => form as UntypedFormGroup)
        .map(podformularzGrupowy => Object.values(podformularzGrupowy.controls).map(obiektPodformularzaGrupowego => obiektPodformularzaGrupowego.markAsTouched()))
    }
    else {
      obiektPodformularza.markAsTouched()
    }
  }

  private sprawdzWalidacjeWFormularzuLokalizacjiUszkodzenia(): void {
    Object.values(this.formularzLokalizacjiUszkodzenia.controls)
      .map(poleFormularza => poleFormularza.markAsTouched())
  }

  sprawdzPoprawnoscFormularza(formularz: UntypedFormGroup): boolean {
    return Object.keys(formularz.controls).length !== 0 && formularz.valid
  }

  dodajPodformularzUszkodzenia(formularz: any, index?: string): void {
    this.ostatnioDodanyFormularz = formularz.formularz;
    this.formularzUszkodzen.addControl(this.parseFormularzNazwa(formularz.nazwa, index), this.ostatnioDodanyFormularz)
    this.sprawdzPoprawnoscFormularzaSubscribe(formularz.formularz)
    this.czyFormularzJestPoprawny.next(this.sprawdzPoprawnoscWszystkichPodformularzy());
  }

  usunPodformularzUszkodzenia(name: string, index?: string): void {
    this.formularzUszkodzen.removeControl(this.parseFormularzNazwa(name, index))
    this.czyFormularzJestPoprawny.next(this.sprawdzPoprawnoscWszystkichPodformularzy());
  }

  podFormularzIstnieje(name: string, index?: string): boolean {
    return this.formularzUszkodzen.controls[this.parseFormularzNazwa(name, index)] !== undefined
  }

  przywrocStanPoczatkowyFormularza(): void {
    this.poprawnoscFormularzaSubscription.forEach(sub => sub.unsubscribe())
    this.poprawnoscFormularzaSubscription = []
    this.formularzUszkodzen.controls = {}
    this.formularzUszkodzen.setValue({})
    this.dodaneUszkodzenia = []
  }

  ustawIstniejaceUszkodzenia(uszkodzenia: Uszkodzenie<any>[]): void {
    this.dodaneUszkodzenia = uszkodzenia
  }

  pobierzIstniejaceUszkodzenia(): Uszkodzenie<any>[] {
    return this.dodaneUszkodzenia
  }

  czyIstniejaUszkodzenia(): boolean {
    return this.dodaneUszkodzenia.length > 0
  }

  parseFormularzNazwa(name: string, index: string | undefined): string {
    return `${name}${index !== undefined ? `_${index}` : ''}`
  }
}
